import { Form } from 'antd';
import { useEffect } from 'react';
import useQueryUrlParam from 'core/hooks/useQueryUrlParam';
import DgFilter from 'styles/UI/Filter/DgFilter';
import { filterOptionsType } from 'core/types/components/filterType';
import DgSelectPlanCommissionType from 'components/Basic/DgSelectPlanCommissionType';
import DgInputLabel from 'styles/UI/Input/DgInputLabel';
import { useWindowSize } from 'core/hooks/useWindowSize';
import DgDatePickerLabel from 'styles/UI/DatePicker/DgDatePickerLabel';

const UserPlansCommissionsFilter = () => {
	const { query, resetQuery } = useQueryUrlParam();
	const { width } = useWindowSize();

	const filterOptions: filterOptionsType[] = [
		...(width < 769
			? [
					{
						filterTitle: 'amount',
						filterNames: ['type'],
						formAttribute: Form.useForm(),
						sortNames: ['amount'],
						query,
					},
			  ]
			: [{ filterTitle: '', formAttribute: Form.useForm(), query, filterNames: [] }]),
		{
			filterTitle: 'profits-type',
			filterNames: ['type'],
			filterItems: [<DgSelectPlanCommissionType key='profits-type' label='profits-type' />],
			formAttribute: Form.useForm(),
			query,
		},
		{
			filterTitle: 'invest-id',
			filterNames: ['order_id'],
			filterItems: [<DgInputLabel key='invest-id' label='invest-id' />],
			formAttribute: Form.useForm(),
			query,
		},
		{
			filterTitle: 'transaction-id',
			filterNames: ['transaction_id'],
			filterItems: [<DgInputLabel key='transaction-id' label='transaction-id' />],
			formAttribute: Form.useForm(),
			query,
		},
		{
			filterTitle: 'date-time',
			filterNames: ['created_at_from', 'created_at_to'],
			filterItems: [<DgDatePickerLabel key='date-from' label='date-from' />, <DgDatePickerLabel key='date-to' label='date-to' />],
			formAttribute: Form.useForm(),
			query,
		},
	];
	useEffect(() => {
		filterOptions.map((item) => {
			const { formAttribute } = item;
			const [form] = formAttribute;

			form.setFieldsValue({ ...query });
		});
	}, []);

	return <DgFilter width={width} filterOptions={filterOptions} resetQuery={() => resetQuery(undefined, { tab: query?.tab }, filterOptions)} />;
};

export default UserPlansCommissionsFilter;
